// Feature flags for the application
// These are build-time flags that can be controlled via environment variables.
// FL-224: renamed from REACT_APP_* to VITE_* during the CRA → Vite migration.

export const FEATURES = {
  // Controls whether the Submission Review features are enabled
  SUBMISSION_REVIEW_ENABLED:
    import.meta.env.VITE_SUBMISSION_REVIEW_ENABLED === "true",
} as const;
